import React from 'react'
import EmbroideryErrorInBatchHeader from './EmbroideryErrorInBatchTable/EmbroideryErrorInBatchHeader'
import EmbroideryErrorInBatchRow from './EmbroideryErrorInBatchTable/EmbroideryErrorInBatchRow'

function EmbroideryErrorInBatchTable(props) {
    const { listEmbroideryError, loading, setType, setBrand } = props

    return (
        <div className='EmbroideryErrorInBatchTable'>
            <table className='table table-borderless table-striped'>
                <EmbroideryErrorInBatchHeader/>
                <tbody className='EmbroideryErrorRow'>
                    {
                        !!listEmbroideryError && listEmbroideryError.map((item, i) => {
                            return <EmbroideryErrorInBatchRow
                                key={item._id}
                                index={i}
                                item={item}
                                setType={setType}
                                setBrand={setBrand}
                            />
                        })
                    }
                    {
                        !loading && listEmbroideryError.length === 0 &&
                        <tr>
                            <td colSpan={9}>
                                No result
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    )
}

export default EmbroideryErrorInBatchTable